import { Type } from 'class-transformer'

import MessageEditorWithMediaData from '../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { MessageNodeActionTypes } from '../types'
import BaseSendMessageAction from './BaseAction'

export default class SendMessageAction extends BaseSendMessageAction {
  declare type: MessageNodeActionTypes.Message

  @Type(() => MessageEditorWithMediaData)
  variants!: Array<MessageEditorWithMediaData>
}
